import { Injectable,inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PageURL } from 'src/app/pages/pages';
import { AuthenticationService } from '../services/authentication.service';


@Injectable({
  providedIn: 'root'
})
class PermissionsService  {
  PageURL: typeof PageURL = PageURL;
  
  constructor(public readonly auth: AuthenticationService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const loggedIn = this.auth.checkStorage();
    return loggedIn.then(res => {
      if (res) return true;
      // not logged in so redirect to login page with the return url
      if(state.root.queryParams['lang']) {
        if(state.root.queryParams['pt']){
          this.router.navigate([PageURL.WELCOME], { queryParams: { lang: state.root.queryParams['lang'], returnUrl: state.url.split('?')[0], pt: state.root.queryParams['pt'] }});
        } else {
          this.router.navigate([PageURL.WELCOME], { queryParams: { lang: state.root.queryParams['lang'], returnUrl: state.url.split('?')[0] }});
        }
      } else {
        let urlPath = '/'+state.root.children[0].url.toString();
        let qparam = {};
        if(state.root.queryParams){
          qparam = state.root.queryParams;
        }
        qparam = {returnUrl: urlPath, ...qparam};
        
        //Add urlPath into queryParams as a returnUrl and add each parameter from state.root.queryParams 
        
        return this.router.createUrlTree([PageURL.WELCOME], { queryParams: qparam});
      }
      return false;
    });
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> => {
  return inject(PermissionsService).canActivate(next, state);
}
//If we need to disable animation, we can copy auth guard from mobile app
